import React, { Component } from "react";

import { connect } from "react-redux";

import { sdg1671cActions } from "../../../../../../_actions";
import { TextInput, NumberInput } from "carbon-components-react";


class RowRenderer extends Component {
  constructor(props) {
    super(props);

    this.handleTableChange = this.handleTableChange.bind(this);
    this.getRatiosColumns = this.getRatiosColumns.bind(this);
    this.getRatiosOfYoung = this.getRatiosOfYoung.bind(this);
    this.canCalculateRatio = this.canCalculateRatio.bind(this);
    this.getRatioValue = this.getRatioValue.bind(this);
    this.getYouthRatioValue = this.getYouthRatioValue.bind(this);
  }

  handleTableChange(e) {
    // console.log("name", e.target.name, e.target.value)
    this.props.handleTableChange(e.target.name,e.target.value);
  }

  canCalculateRatio(index, name, denominator) {
    // Check if the ratio can be calculated
    if (!this.props.data || !this.props.data.data) {
      return false;
    }
    
    const male = this.props.data.data[index] && this.props.data.data[index]["male"] ? parseFloat(this.props.data.data[index]["male"]) : 0;
    const female = this.props.data.data[index] && this.props.data.data[index]["female"] ? parseFloat(this.props.data.data[index]["female"]) : 0;
    const val = this.props.data.data[index] && this.props.data.data[index][name] >= 0 ? parseFloat(this.props.data.data[index][name]) : null;
    
    return (male + female) > 0 && val >= 0 && denominator && denominator > 0;
  }

  canCalculateYouthRatio(index) {
    // Check if youth ratio can be calculated
    if (!this.props.data || !this.props.data["age_under_45_ratio"] || this.props.data["age_under_45_ratio"] === 0) {
      return false;
    }
    
    const male = this.props.data.data[index] && this.props.data.data[index]["male"] ? parseFloat(this.props.data.data[index]["male"]) : 0;
    const female = this.props.data.data[index] && this.props.data.data[index]["female"] ? parseFloat(this.props.data.data[index]["female"]) : 0;
    const age_under_35 = this.props.data.data[index] && this.props.data.data[index]["age_under_35"] ? parseFloat(this.props.data.data[index]["age_under_35"]) : 0;
    const between_35_44 = this.props.data.data[index] && this.props.data.data[index]["between_35_44"] ? parseFloat(this.props.data.data[index]["between_35_44"]) : 0;
    
    return (male + female) > 0 && (age_under_35 + between_35_44 > 0);
  }

  getRatioValue(index, name, denominator, fieldName) {
    const isOGC = this.props.user && this.props.user.user_type === "OGC";
    const canCalculate = this.canCalculateRatio(index, name, denominator);
    
    // Ratios are stored at the same index as the data (index for judges, index+4 for registrars)
    const ratioIndex = index;
    
    // If value can be calculated, always use calculated value (calculation takes priority)
    if (canCalculate) {
      return this.getRatiosColumns(index, name, denominator, ratioIndex);
    }
    
    // If user is currently editing this field, return the local value
    if (isOGC && this.props.editingFields) {
      const editingKey = `${this.props.index}:proportion:${name}:${fieldName}`;
      if (this.props.editingFields[editingKey] !== undefined) {
        return this.props.editingFields[editingKey];
      }
    }
    
    // If calculation is not possible, return stored value (for both OGC and non-OGC users)
    if (this.props.data && this.props.data.ratios && this.props.data.ratios[ratioIndex]) {
      const storedValue = this.props.data.ratios[ratioIndex][name];
      
      // If value is null, undefined, or 0, show "0.00" by default
      if (storedValue === null || storedValue === undefined || storedValue === 0) {
        return "0.00";
      }
      
      // Return formatted stored value
      return parseFloat(storedValue).toFixed(2);
    }
    
    // If no data exists at all, return "0.00"
    return "0.00";
  }

  getYouthRatioValue(index, fieldName) {
    const isOGC = this.props.user && this.props.user.user_type === "OGC";
    const canCalculate = this.canCalculateYouthRatio(index);
    
    // Ratios are stored at the same index as the data (index for judges, index+4 for registrars)
    const ratioIndex = index;
    
    // If value can be calculated, always use calculated value
    if (canCalculate) {
      return this.getRatiosOfYoung(index, ratioIndex);
    }
    
    // If user is currently editing this field, return the local value
    if (isOGC && this.props.editingFields) {
      const editingKey = `${this.props.index}:proportion:young:${fieldName}`;
      if (this.props.editingFields[editingKey] !== undefined) {
        return this.props.editingFields[editingKey];
      }
    }
    
    // If calculation is not possible, return stored value (for both OGC and non-OGC users)
    if (this.props.data && this.props.data.ratios && this.props.data.ratios[ratioIndex]) {
      const storedValue = this.props.data.ratios[ratioIndex]["age_under_44"];
      
      // If value is null, undefined, or 0, show "0.00" by default
      if (storedValue === null || storedValue === undefined || storedValue === 0) {
        return "0.00";
      }
      
      // Return formatted stored value
      return parseFloat(storedValue).toFixed(2);
    }
    
    // If no data exists at all, return "0.00"
    return "0.00";
  }

  getRatiosColumns(index, name, denominator, ratioIndex) {
    const male = this.props.data.data[index]["male"] ? parseFloat(this.props.data.data[index]["male"]) : 0
    const female = this.props.data.data[index]["female"] ? parseFloat(this.props.data.data[index]["female"]) : 0
    const val = this.props.data.data[index][name] >= 0 ? parseFloat(this.props.data.data[index][name]) : null;

    // Auto-update if the stored value is null or different from calculated value
    // Use ratioIndex for storing ratios (same as judges index for registrars)
    if (
      this.props.data && 
      this.props.data.data && 
      this.props.data.data[index][name] >=0 && 
      this.props.data.ratios &&
      this.props.data.ratios.length > 0 &&
      denominator && denominator > 0 &&
      (male + female) > 0 &&
      (
        this.props.data.ratios[ratioIndex][name] === null || 
            (parseFloat(this.props.data.ratios[ratioIndex][name]).toFixed(2) !== (this.props.data.data[index][name]/(female + male)*100/denominator).toFixed(2)))
      ) 
      {
        this.props.updateRatiosField(ratioIndex, name, parseFloat(((this.props.data.data[index][name]/(female + male))*100/denominator).toFixed(2)))
      }
    return (male + female) > 0 && val >= 0 &&
           denominator && 
           denominator > 0 ?((parseFloat(this.props.data.data[index][name])/(female + male))*100/denominator).toFixed(2): '';
  }
  
  getRatiosOfYoung(index, ratioIndex) {
    const male = this.props.data.data[index]["male"] ? parseFloat(this.props.data.data[index]["male"]) : 0
    const female = this.props.data.data[index]["female"] ? parseFloat(this.props.data.data[index]["female"]) : 0
    const age_under_35 = this.props.data.data[index]["age_under_35"] ? parseFloat(this.props.data.data[index]["age_under_35"]) : 0;
    const between_35_44 = this.props.data.data[index]["between_35_44"] ? parseFloat(this.props.data.data[index]["between_35_44"]) : 0;

    const calculatedValue = (male + female) > 0 && (age_under_35 + between_35_44 > 0) && this.props.data["age_under_45_ratio"] ? 
      (parseFloat(age_under_35 + between_35_44) / parseFloat(male + female) * 100 / parseFloat(this.props.data["age_under_45_ratio"])).toFixed(2) : "";

    // Auto-update if the stored value is null or different from calculated value
    // Use ratioIndex for storing ratios (same as judges index for registrars)
    if (this.props.data && 
      this.props.data.ratios &&
      this.props.data.ratios.length > 0 &&
      this.props.data["age_under_45_ratio"] &&
      this.props.data["age_under_45_ratio"] > 0 &&
      (male + female) > 0 &&
      (age_under_35 + between_35_44 > 0) && 
      calculatedValue !== "" &&
      (this.props.data.ratios[ratioIndex]["age_under_44"] === null ||
            (parseFloat(this.props.data.ratios[ratioIndex]["age_under_44"]).toFixed(2) !== calculatedValue))) {
      this.props.updateRatiosField(ratioIndex, "age_under_44", parseFloat(calculatedValue));     
    }

    return calculatedValue;
  }


  render() {
    return (
      <React.Fragment>
        <tr>
          <td style={{background:this.props.title.indexOf("Total") !== -1 ? "#FFC000": "white"}}>
            {this.props.title}
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:female:judges`}
              name={`${this.props.index}:proportion:female:judges`}
              // className="input-1671b"
              labelText=""
              onChange={this.props.onRatioChange}
              onFocus={this.props.onRatioFocus}
              onBlur={this.props.onRatioBlur}
              value={this.getRatioValue(this.props.index, "female", 50, "judges")}
              disabled={
                !(this.props.user && this.props.user.user_type === "OGC") ||
                this.canCalculateRatio(this.props.index, "female", 50)
              }
            />
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:female:registrars`}
              name={`${this.props.index}:proportion:female:registrars`}
              // className="input-1671b"
              labelText=""
              onChange={this.props.onRatioChange}
              onFocus={this.props.onRatioFocus}
              onBlur={this.props.onRatioBlur}
              value={this.getRatioValue(this.props.index+4, "female", 50, "registrars")}
              disabled={
                !(this.props.user && this.props.user.user_type === "OGC") ||
                this.canCalculateRatio(this.props.index+4, "female", 50)
              }
            />
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:young:judges`}
              name={`${this.props.index}:proportion:young:judges`}
              // className="input-1671b"
              labelText=""
              onChange={this.props.onRatioChange}
              onFocus={this.props.onRatioFocus}
              onBlur={this.props.onRatioBlur}
              value={this.getYouthRatioValue(this.props.index, "judges")}
              disabled={
                !(this.props.user && this.props.user.user_type === "OGC") ||
                this.canCalculateYouthRatio(this.props.index)
              }
            />
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:young:registrars`}
              name={`${this.props.index}:proportion:young:registrars`}
              // className="input-1671b"
              labelText=""
              onChange={this.props.onRatioChange}
              onFocus={this.props.onRatioFocus}
              onBlur={this.props.onRatioBlur}
              value={this.getYouthRatioValue(this.props.index+4, "registrars")}
              disabled={
                !(this.props.user && this.props.user.user_type === "OGC") ||
                this.canCalculateYouthRatio(this.props.index+4)
              }
            />
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:disabled:judges`}
              name={`${this.props.index}:proportion:disabled:judges`}
              // className="input-1671b"
              labelText=""
              onChange={this.props.onRatioChange}
              onFocus={this.props.onRatioFocus}
              onBlur={this.props.onRatioBlur}
              value={this.getRatioValue(this.props.index, "disabled", this.props.data["disability_ratio"], "judges")}
              disabled={
                !(this.props.user && this.props.user.user_type === "OGC") ||
                this.canCalculateRatio(this.props.index, "disabled", this.props.data["disability_ratio"])
              }
            />
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:disabled:registrars`}
              name={`${this.props.index}:proportion:disabled:registrars`}
              // className="input-1671b"
              labelText=""
              onChange={this.props.onRatioChange}
              onFocus={this.props.onRatioFocus}
              onBlur={this.props.onRatioBlur}
              value={this.getRatioValue(this.props.index+4, "disabled", this.props.data["disability_ratio"], "registrars")}
              disabled={
                !(this.props.user && this.props.user.user_type === "OGC") ||
                this.canCalculateRatio(this.props.index+4, "disabled", this.props.data["disability_ratio"])
              }
            />
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:group_a:judges`}
              name={`${this.props.index}:proportion:group_a:judges`}
              // className="input-1671b"
              labelText=""
              onChange={this.props.onRatioChange}
              onFocus={this.props.onRatioFocus}
              onBlur={this.props.onRatioBlur}
              value={this.getRatioValue(this.props.index, "group_a", this.props.data["group_a_ratio"], "judges")}
              disabled={
                !(this.props.user && this.props.user.user_type === "OGC") ||
                this.canCalculateRatio(this.props.index, "group_a", this.props.data["group_a_ratio"])
              }
            />
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:group_a:registrars`}
              name={`${this.props.index}:proportion:group_a:registrars`}
              // className="input-1671b"
              labelText=""
              onChange={this.props.onRatioChange}
              onFocus={this.props.onRatioFocus}
              onBlur={this.props.onRatioBlur}
              value={this.getRatioValue(this.props.index+4, "group_a", this.props.data["group_a_ratio"], "registrars")}
              disabled={
                !(this.props.user && this.props.user.user_type === "OGC") ||
                this.canCalculateRatio(this.props.index+4, "group_a", this.props.data["group_a_ratio"])
              }
            />
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:group_b:judges`}
              name={`${this.props.index}:proportion:group_b:judges`}
              // className="input-1671b"
              labelText=""
              onChange={this.props.onRatioChange}
              onFocus={this.props.onRatioFocus}
              onBlur={this.props.onRatioBlur}
              value={this.getRatioValue(this.props.index, "group_b", this.props.data["group_b_ratio"], "judges")}
              disabled={
                !(this.props.user && this.props.user.user_type === "OGC") ||
                this.canCalculateRatio(this.props.index, "group_b", this.props.data["group_b_ratio"])
              }
            />
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:group_b:registrars`}
              name={`${this.props.index}:proportion:group_b:registrars`}
              // className="input-1671b"
              labelText=""
              onChange={this.props.onRatioChange}
              onFocus={this.props.onRatioFocus}
              onBlur={this.props.onRatioBlur}
              value={this.getRatioValue(this.props.index+4, "group_b", this.props.data["group_b_ratio"], "registrars")}
              disabled={
                !(this.props.user && this.props.user.user_type === "OGC") ||
                this.canCalculateRatio(this.props.index+4, "group_b", this.props.data["group_b_ratio"])
              }
            />
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:group_c:judges`}
              name={`${this.props.index}:proportion:group_c:judges`}
              // className="input-1671b"
              labelText=""
              onChange={this.props.onRatioChange}
              onFocus={this.props.onRatioFocus}
              onBlur={this.props.onRatioBlur}
              value={this.getRatioValue(this.props.index, "group_c", this.props.data["group_c_ratio"], "judges")}
              disabled={
                !(this.props.user && this.props.user.user_type === "OGC") ||
                this.canCalculateRatio(this.props.index, "group_c", this.props.data["group_c_ratio"])
              }
            />
          </td>
          <td>
            <TextInput
              id={`${this.props.index}:proportion:group_c:registrars`}
              name={`${this.props.index}:proportion:group_c:registrars`}
              // className="input-1671b"
              labelText=""
              onChange={this.props.onRatioChange}
              onFocus={this.props.onRatioFocus}
              onBlur={this.props.onRatioBlur}
              value={this.getRatioValue(this.props.index+4, "group_c", this.props.data["group_c_ratio"], "registrars")}
              disabled={
                !(this.props.user && this.props.user.user_type === "OGC") ||
                this.canCalculateRatio(this.props.index+4, "group_c", this.props.data["group_c_ratio"])
              }
            />
          </td>        
          </tr>
      </React.Fragment>
    )
  }

}

class RatiosTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: props.data,
      error: props.error,
      editingFields: {}, // Track fields being edited locally
      focusedFields: {} // Track which fields are focused
    };

    this.handleRatiosChange = this.handleRatiosChange.bind(this);
    this.goToMetadata = this.goToMetadata.bind(this);
    this.updateDenominator = this.updateDenominator.bind(this);
    this.handleRatioChange = this.handleRatioChange.bind(this);
    this.handleRatioFocus = this.handleRatioFocus.bind(this);
    this.handleRatioBlur = this.handleRatioBlur.bind(this);
  }

  handleRatiosChange(index, name, value) {
    let { dispatch } = this.props;

    dispatch(
      sdg1671cActions.updateRatiosField(index, name, value)
    );
  }

  handleRatioChange(e) {
    const isOGC = this.props.user && this.props.user.user_type === "OGC";
    
    if (isOGC) {
      // For OGC users, store the value locally while typing
      this.setState({
        editingFields: {
          ...this.state.editingFields,
          [e.target.name]: e.target.value
        }
      });
    } else {
      // For non-OGC users, parse and update Redux directly
      const nameParts = e.target.name.split(":");
      const baseIndex = parseInt(nameParts[0]);
      const type = nameParts[3]; // "judges" or "registrars"
      // Field name format: index:proportion:fieldName:type
      // For "young" fields, the stored field name is "age_under_44"
      // For others, it's the field name (female, disabled, group_a, etc.)
      let fieldName = nameParts[2];
      if (fieldName === "young") {
        fieldName = "age_under_44";
      }
      
      // For registrars, data is at index+4
      const actualIndex = type === "registrars" ? baseIndex + 4 : baseIndex;
      const value = parseFloat(e.target.value) || null;
      
      let { dispatch } = this.props;
      dispatch(
        sdg1671cActions.updateRatiosField(actualIndex, fieldName, value)
      );
    }
  }

  handleRatioFocus(e) {
    const isOGC = this.props.user && this.props.user.user_type === "OGC";
    
    if (isOGC) {
      // Track that this field is focused
      this.setState({
        focusedFields: {
          ...this.state.focusedFields,
          [e.target.name]: true
        }
      });
      
      // Get stored value
      const nameParts = e.target.name.split(":");
      const baseIndex = parseInt(nameParts[0]);
      const type = nameParts[3]; // "judges" or "registrars"
      let fieldName = nameParts[2];
      if (fieldName === "young") {
        fieldName = "age_under_44";
      }
      
      // For registrars, data is at index+4
      const actualIndex = type === "registrars" ? baseIndex + 4 : baseIndex;
      
      const storedValue = this.props.data && this.props.data.ratios && this.props.data.ratios[actualIndex]
        ? this.props.data.ratios[actualIndex][fieldName]
        : null;
      
      if (storedValue === null || storedValue === undefined || storedValue === 0) {
        this.setState({
          editingFields: {
            ...this.state.editingFields,
            [e.target.name]: ""
          }
        });
      } else {
        this.setState({
          editingFields: {
            ...this.state.editingFields,
            [e.target.name]: String(storedValue)
          }
        });
      }
    }
  }

  handleRatioBlur(e) {
    const isOGC = this.props.user && this.props.user.user_type === "OGC";
    
    if (isOGC) {
      const nameParts = e.target.name.split(":");
      const baseIndex = parseInt(nameParts[0]);
      const type = nameParts[3]; // "judges" or "registrars"
      let fieldName = nameParts[2];
      if (fieldName === "young") {
        fieldName = "age_under_44";
      }
      
      // For registrars, data is at index+4
      const actualIndex = type === "registrars" ? baseIndex + 4 : baseIndex;
      
      const inputValue = e.target.value.trim();
      
      let value;
      if (inputValue === "" || inputValue === "0" || inputValue === "0.00" || inputValue === "0.0") {
        value = null;
      } else {
        const parsed = parseFloat(inputValue);
        value = isNaN(parsed) ? null : parsed;
      }
      
      let { dispatch } = this.props;
      dispatch(
        sdg1671cActions.updateRatiosField(actualIndex, fieldName, value)
      );
      
      // Clear local editing and focus state
      const newEditingFields = { ...this.state.editingFields };
      const newFocusedFields = { ...this.state.focusedFields };
      delete newEditingFields[e.target.name];
      delete newFocusedFields[e.target.name];
      this.setState({ 
        editingFields: newEditingFields,
        focusedFields: newFocusedFields
      });
    }
  }

  goToMetadata() {
    this.props.onPrevious();
  }

  updateDenominator(e) {
    let { dispatch } = this.props;

    dispatch(
      sdg1671cActions.updateMetadataField(e.target.name, e.target.value)
    );
  }

  
  
  render() {

    return (
      <React.Fragment>
        <div className="box-body">
          <div className="col-sm-8">
            <h4>Step 3: Ratios compared to overall working-age population</h4>
          </div>
          <div className="row">
            <div className="col-sm-12 adaptive-table">
              <fieldset
                disabled={this.props.data && (!this.props.data.id || this.props.data.id === null)}
              >
                <table className="table table-bordered table-1671b">
                  <thead style={{fontSize:"0.9vw"}}>
                    <tr>
                      <th rowSpan="2" style={{ width: "18%" }}></th>
                      <th colSpan="2">Female representation ratios: Proportion of female judges and registrars / Proportion of women in the working-age population</th>
                      <th colSpan="2">‘Youth’ representation ratios: Proportion of ‘young’ judges and registrars aged 44 and below / Proportion of the working-age population aged above the eligibility age and below 45</th>
                      <th colSpan="2">Disability representation ratios: Proportion of judges and registrars with a disability / Proportion of persons with a disability in the working-age population</th>
                      <th colSpan="2">Population group(s) representation ratios: Proportion of judges and registrars in population group A / Proportion of persons in given population group in the working-age population</th>
                      <th colSpan="2">Population group(s) representation ratios: Proportion of judges and registrars in population group B / Proportion of persons in given population group in the working-age population</th>
                      <th colSpan="2">Population group(s) representation ratios: Proportion of judges and registrars in population group C / Proportion of persons in given population group in the working-age population</th>
                    </tr>
                    <tr>
                      <th>Denominator</th>
                      <th>50%</th>
                      <th>Denominator</th>
                      <th>
                      <NumberInput
                          id="age_under_45_ratio"
                          name="age_under_45_ratio"
                          // className="input-1671b"
                          label=""
                          onChange={this.updateDenominator}
                          value={
                            this.props.data && this.props.data["age_under_45_ratio"]
                              ? this.props.data["age_under_45_ratio"]
                              : 0
                          }
                        />
                      </th>
                      <th>Denominator</th>
                      <th>
                      <NumberInput
                          id="disability_ratio"
                          name="disability_ratio"
                          // className="input-1671b"
                          label=""
                          onChange={this.updateDenominator}
                          value={
                            this.props.data && this.props.data["disability_ratio"]
                              ? this.props.data["disability_ratio"]
                              : 0
                          }
                        />
                      </th>
                      <th>Denominator</th>
                      <th>
                      <NumberInput
                          id="group_a_ratio"
                          name="group_a_ratio"
                          // className="input-1671b"
                          label=""
                          onChange={this.updateDenominator}
                          value={
                            this.props.data && this.props.data["group_a_ratio"]
                              ? this.props.data["group_a_ratio"]
                              : 0
                          }
                        />
                      </th>
                      <th>Denominator</th>
                      <th>
                      <NumberInput
                          id="group_b_ratio"
                          name="group_b_ratio"
                          // className="input-1671b"
                          label=""
                          onChange={this.updateDenominator}
                          value={
                            this.props.data && this.props.data["group_b_ratio"]
                              ? this.props.data["group_b_ratio"]
                              : 0
                          }
                        />
                      </th>
                      <th>Denominator</th>
                      <th>
                      <NumberInput
                          id="group_c_ratio"
                          name="group_c_ratio"
                          // className="input-1671b"
                          label=""
                          onChange={this.updateDenominator}
                          value={
                            this.props.data && this.props.data["group_c_ratio"]
                              ? this.props.data["group_c_ratio"]
                              : 0
                          }
                        />
                      </th>
                    </tr>
                    <tr>
                      <th></th>
                      <th>Judges</th>
                      <th>Registrars</th>
                      <th>Judges</th>
                      <th>Registrars</th>
                      <th>Judges</th>
                      <th>Registrars</th>
                      <th>Judges</th>
                      <th>Registrars</th>
                      <th>Judges</th>
                      <th>Registrars</th>
                      <th>Judges</th>
                      <th>Registrars</th>
                    </tr>

                  </thead>
                  <tbody style={{fontSize:"0.95vw"}}>
                    <RowRenderer
                      index={2}
                      data={this.props.data}
                      title={"Constitutional / supreme courts"}
                      updateRatiosField={this.handleRatiosChange}
                      user={this.props.user}
                      editingFields={this.state.editingFields}
                      onRatioChange={this.handleRatioChange}
                      onRatioFocus={this.handleRatioFocus}
                      onRatioBlur={this.handleRatioBlur}
                      />
                    <RowRenderer
                      title={"Higher-level courts"}
                      index={0}
                      data={this.props.data}
                      updateRatiosField={this.handleRatiosChange}
                      user={this.props.user}
                      editingFields={this.state.editingFields}
                      onRatioChange={this.handleRatioChange}
                      onRatioFocus={this.handleRatioFocus}
                      onRatioBlur={this.handleRatioBlur}
                      />
                    <RowRenderer
                      title={"Lower-level courts"}
                      index={1}
                      data={this.props.data}
                      updateRatiosField={this.handleRatiosChange}
                      user={this.props.user}
                      editingFields={this.state.editingFields}
                      onRatioChange={this.handleRatioChange}
                      onRatioFocus={this.handleRatioFocus}
                      onRatioBlur={this.handleRatioBlur}
                      />
                    <RowRenderer
                      title={"Total (across all levels of courts)"}
                      index={3}
                      data={this.props.data}
                      updateRatiosField={this.handleRatiosChange}
                      user={this.props.user}
                      editingFields={this.state.editingFields}
                      onRatioChange={this.handleRatioChange}
                      onRatioFocus={this.handleRatioFocus}
                      onRatioBlur={this.handleRatioBlur}
                      />
                  </tbody>
                </table>
              </fieldset>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { data } = state.sdg1671cState;
  const { user } = state.authentication;

  return {
    data,
    user
  };
}

const connectedIndicatorData = connect(mapStateToProps)(RatiosTable);

export { connectedIndicatorData as RatiosTable };
